var cov_k6x9bbia1 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/TreeSelect/datum.tsx",
      hash = "8f38fa539bd460deace2a7b68fd6aef80090cc55",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/TreeSelect/datum.tsx",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 2
        },
        end: {
          line: 8,
          column: 23
        }
      },
      "1": {
        start: {
          line: 8,
          column: 14
        },
        end: {
          line: 8,
          column: 23
        }
      },
      "2": {
        start: {
          line: 9,
          column: 2
        },
        end: {
          line: 9,
          column: 43
        }
      },
      "3": {
        start: {
          line: 9,
          column: 29
        },
        end: {
          line: 9,
          column: 43
        }
      },
      "4": {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 10,
          column: 14
        }
      },
      "5": {
        start: {
          line: 16,
          column: 2
        },
        end: {
          line: 62,
          column: 3
        }
      },
      "6": {
        start: {
          line: 26,
          column: 6
        },
        end: {
          line: 26,
          column: 18
        }
      },
      "7": {
        start: {
          line: 28,
          column: 6
        },
        end: {
          line: 38,
          column: 8
        }
      },
      "8": {
        start: {
          line: 42,
          column: 6
        },
        end: {
          line: 47,
          column: 7
        }
      },
      "9": {
        start: {
          line: 43,
          column: 29
        },
        end: {
          line: 43,
          column: 39
        }
      },
      "10": {
        start: {
          line: 44,
          column: 8
        },
        end: {
          line: 44,
          column: 88
        }
      },
      "11": {
        start: {
          line: 45,
          column: 8
        },
        end: {
          line: 45,
          column: 49
        }
      },
      "12": {
        start: {
          line: 46,
          column: 8
        },
        end: {
          line: 46,
          column: 26
        }
      },
      "13": {
        start: {
          line: 51,
          column: 24
        },
        end: {
          line: 51,
          column: 34
        }
      },
      "14": {
        start: {
          line: 52,
          column: 20
        },
        end: {
          line: 55,
          column: 7
        }
      },
      "15": {
        start: {
          line: 57,
          column: 6
        },
        end: {
          line: 59,
          column: 7
        }
      },
      "16": {
        start: {
          line: 58,
          column: 8
        },
        end: {
          line: 58,
          column: 61
        }
      },
      "17": {
        start: {
          line: 60,
          column: 6
        },
        end: {
          line: 60,
          column: 34
        }
      }
    },
    fnMap: {
      "0": {
        name: "toArray",
        decl: {
          start: {
            line: 7,
            column: 9
          },
          end: {
            line: 7,
            column: 16
          }
        },
        loc: {
          start: {
            line: 7,
            column: 38
          },
          end: {
            line: 11,
            column: 1
          }
        },
        line: 7
      },
      "1": {
        name: "datum",
        decl: {
          start: {
            line: 13,
            column: 24
          },
          end: {
            line: 13,
            column: 29
          }
        },
        loc: {
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 63,
            column: 1
          }
        },
        line: 15
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 25,
            column: 5
          }
        },
        loc: {
          start: {
            line: 25,
            column: 62
          },
          end: {
            line: 39,
            column: 5
          }
        },
        line: 25
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 41,
            column: 5
          }
        },
        loc: {
          start: {
            line: 41,
            column: 73
          },
          end: {
            line: 48,
            column: 5
          }
        },
        line: 41
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 50,
            column: 5
          }
        },
        loc: {
          start: {
            line: 50,
            column: 13
          },
          end: {
            line: 61,
            column: 5
          }
        },
        line: 50
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 8,
            column: 2
          },
          end: {
            line: 8,
            column: 23
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 8,
            column: 2
          },
          end: {
            line: 8,
            column: 23
          }
        }, {
          start: {
            line: 8,
            column: 2
          },
          end: {
            line: 8,
            column: 23
          }
        }],
        line: 8
      },
      "1": {
        loc: {
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 9,
            column: 43
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 9,
            column: 43
          }
        }, {
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 9,
            column: 43
          }
        }],
        line: 9
      },
      "2": {
        loc: {
          start: {
            line: 35,
            column: 18
          },
          end: {
            line: 35,
            column: 83
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 35,
            column: 57
          },
          end: {
            line: 35,
            column: 71
          }
        }, {
          start: {
            line: 35,
            column: 74
          },
          end: {
            line: 35,
            column: 83
          }
        }],
        line: 35
      },
      "3": {
        loc: {
          start: {
            line: 36,
            column: 21
          },
          end: {
            line: 36,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 36,
            column: 21
          },
          end: {
            line: 36,
            column: 38
          }
        }, {
          start: {
            line: 36,
            column: 42
          },
          end: {
            line: 36,
            column: 52
          }
        }],
        line: 36
      },
      "4": {
        loc: {
          start: {
            line: 42,
            column: 6
          },
          end: {
            line: 47,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 42,
            column: 6
          },
          end: {
            line: 47,
            column: 7
          }
        }, {
          start: {
            line: 42,
            column: 6
          },
          end: {
            line: 47,
            column: 7
          }
        }],
        line: 42
      },
      "5": {
        loc: {
          start: {
            line: 44,
            column: 34
          },
          end: {
            line: 44,
            column: 87
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 44,
            column: 67
          },
          end: {
            line: 44,
            column: 75
          }
        }, {
          start: {
            line: 44,
            column: 78
          },
          end: {
            line: 44,
            column: 87
          }
        }],
        line: 44
      },
      "6": {
        loc: {
          start: {
            line: 57,
            column: 6
          },
          end: {
            line: 59,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 57,
            column: 6
          },
          end: {
            line: 59,
            column: 7
          }
        }, {
          start: {
            line: 57,
            column: 6
          },
          end: {
            line: 59,
            column: 7
          }
        }],
        line: 57
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectSpread2 from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/TreeSelect/datum.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import DatumTree from '../Datum/Tree';
import shallowEqual from '../utils/shallowEqual';

function toArray(value) {
  cov_k6x9bbia1.f[0]++;
  cov_k6x9bbia1.s[0]++;

  if (!value) {
    cov_k6x9bbia1.b[0][0]++;
    cov_k6x9bbia1.s[1]++;
    return [];
  } else {
    cov_k6x9bbia1.b[0][1]++;
  }

  cov_k6x9bbia1.s[2]++;

  if (!Array.isArray(value)) {
    cov_k6x9bbia1.b[1][0]++;
    cov_k6x9bbia1.s[3]++;
    return [value];
  } else {
    cov_k6x9bbia1.b[1][1]++;
  }

  cov_k6x9bbia1.s[4]++;
  return value;
}

export default function datum(Origin) {
  var _class, _temp;

  cov_k6x9bbia1.f[1]++;
  cov_k6x9bbia1.s[5]++;
  return _temp = _class =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(TreeDatum, _React$Component);

    var _super = _createSuper2(TreeDatum);

    function TreeDatum(props) {
      var _this;

      _classCallCheck(this, TreeDatum);

      cov_k6x9bbia1.f[2]++;
      cov_k6x9bbia1.s[6]++;
      _this = _super.call(this, props);
      _this.datum = void 0;
      cov_k6x9bbia1.s[7]++;
      _this.datum = new DatumTree({
        data: props.data,
        loader: props.loader,
        keygen: props.keygen,
        mode: props.mode,
        value: toArray(props.value),
        onChange: props.onChange,
        disabled: typeof props.disabled === 'function' ? (cov_k6x9bbia1.b[2][0]++, props.disabled) : (cov_k6x9bbia1.b[2][1]++, undefined),
        childrenKey: (cov_k6x9bbia1.b[3][0]++, props.childrenKey) || (cov_k6x9bbia1.b[3][1]++, 'children'),
        unmatch: props.unmatch
      });
      return _this;
    }

    _createClass(TreeDatum, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        cov_k6x9bbia1.f[3]++;
        cov_k6x9bbia1.s[8]++;

        if (!shallowEqual(prevProps.data, this.props.data)) {
          cov_k6x9bbia1.b[4][0]++;

          var _ref = (cov_k6x9bbia1.s[9]++, this.props),
              disabled = _ref.disabled;

          cov_k6x9bbia1.s[10]++;
          this.datum.updateDisabled(typeof disabled === 'function' ? (cov_k6x9bbia1.b[5][0]++, disabled) : (cov_k6x9bbia1.b[5][1]++, undefined));
          cov_k6x9bbia1.s[11]++;
          this.datum.setData(this.props.data, true);
          cov_k6x9bbia1.s[12]++;
          this.forceUpdate();
        } else {
          cov_k6x9bbia1.b[4][1]++;
        }
      }
    }, {
      key: "render",
      value: function render() {
        cov_k6x9bbia1.f[4]++;

        var _ref2 = (cov_k6x9bbia1.s[13]++, this.props),
            value = _ref2.value;

        var props = (cov_k6x9bbia1.s[14]++, _objectSpread2(_objectSpread2({}, this.props), {}, {
          datum: this.datum
        }));
        cov_k6x9bbia1.s[15]++;

        if (!shallowEqual(toArray(value), this.datum.getValue())) {
          cov_k6x9bbia1.b[6][0]++;
          cov_k6x9bbia1.s[16]++;
          this.datum.setValue(toArray(value));
        } else {
          cov_k6x9bbia1.b[6][1]++;
        }

        cov_k6x9bbia1.s[17]++;
        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, props, {
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 60,
              columnNumber: 14
            }
          }))
        );
      }
    }]);

    return TreeDatum;
  }(React.Component), _class.defaultProps = {
    mode: 1,
    childrenKey: 'children',
    unmatch: true
  }, _temp;
}